import { render, staticRenderFns } from "./orgTreeModal.vue?vue&type=template&id=199abc51";
import script from "./orgTreeModal.vue?vue&type=script&lang=js";
export * from "./orgTreeModal.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;